export const ActionTypes = {
  LOADING: "GUEST_SIGNIN_LOADING",
  ERROR: "GUEST_SIGNIN_ERROR",
  SUCCESS: "GUEST_SIGNIN_SUCCESS",
};
